export default "__VITE_ASSET__Cltcv4tP__"